export const environment = {
  production: true,
  contentful: {
    space: 'yflmmil4eap5',
    accessToken: 'UmKiUyons-Hk6yp4pTePZiKL_Lt0_x8Umire5GnDAzg',
  },
  urlToBackend: 'https://pressberg-prod.herokuapp.com'
};
